import { lib } from '@actual-app/core/server/main';

export const amountToInteger = lib.amountToInteger;
export const integerToAmount = lib.integerToAmount;
